declare namespace $ {

	type $mol_image__uri_bog_smalljs_top_1 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['logo_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_bog_smalljs_top_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['title'] >
	>
	type $mol_view__sub_bog_smalljs_top_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_bog_smalljs_top_4 = $mol_type_enforce<
		({ 
			'section': any,
			'page': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_bog_smalljs_top_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_smalljs_top_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_top_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_smalljs_top_8 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['search_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_smalljs_top_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_link__title_bog_smalljs_top_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_11 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_12 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_14 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_15 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $bog_smalljs_top_item__title_bog_smalljs_top_16 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_top_item['title'] >
	>
	type $bog_smalljs_top_item__arg_bog_smalljs_top_17 = $mol_type_enforce<
		({ 
			'section': string,
			'page': any,
		}) 
		,
		ReturnType< $bog_smalljs_top_item['arg'] >
	>
	type $bog_smalljs_top_item__event_click_bog_smalljs_top_18 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $bog_smalljs_top_item['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_20 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_21 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_23 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_24 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_view__sub_bog_smalljs_top_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__hint_bog_smalljs_top_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__align_bog_smalljs_top_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__trigger_content_bog_smalljs_top_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_bog_smalljs_top_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $bog_smalljs_top_item__title_bog_smalljs_top_30 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_top_item['title'] >
	>
	type $bog_smalljs_top_item__arg_bog_smalljs_top_31 = $mol_type_enforce<
		({ 
			'section': string,
			'page': any,
		}) 
		,
		ReturnType< $bog_smalljs_top_item['arg'] >
	>
	type $bog_smalljs_top_item__title_bog_smalljs_top_32 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_top_item['title'] >
	>
	type $bog_smalljs_top_item__arg_bog_smalljs_top_33 = $mol_type_enforce<
		({ 
			'section': string,
			'page': any,
		}) 
		,
		ReturnType< $bog_smalljs_top_item['arg'] >
	>
	type $mol_link__title_bog_smalljs_top_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_35 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_36 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_view__sub_bog_smalljs_top_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__title_bog_smalljs_top_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_39 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_40 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_41 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_42 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_43 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_44 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_45 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_46 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_47 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_48 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_49 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_50 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_51 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_52 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_53 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_54 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_55 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_view__sub_bog_smalljs_top_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__hint_bog_smalljs_top_57 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__align_bog_smalljs_top_58 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__trigger_content_bog_smalljs_top_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_bog_smalljs_top_60 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_link__title_bog_smalljs_top_61 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_62 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_63 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_64 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_65 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_66 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_67 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_68 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_69 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_70 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_71 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_72 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_view__sub_bog_smalljs_top_73 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__hint_bog_smalljs_top_74 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__align_bog_smalljs_top_75 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__trigger_content_bog_smalljs_top_76 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_bog_smalljs_top_77 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__sub_bog_smalljs_top_78 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_top_item__title_bog_smalljs_top_79 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_top_item['title'] >
	>
	type $bog_smalljs_top_item__arg_bog_smalljs_top_80 = $mol_type_enforce<
		({ 
			'section': string,
			'page': any,
		}) 
		,
		ReturnType< $bog_smalljs_top_item['arg'] >
	>
	type $bog_smalljs_top_item__event_click_bog_smalljs_top_81 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $bog_smalljs_top_item['event_click'] >
	>
	type $bog_smalljs_top_item__title_bog_smalljs_top_82 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_top_item['title'] >
	>
	type $bog_smalljs_top_item__arg_bog_smalljs_top_83 = $mol_type_enforce<
		({ 
			'section': string,
			'page': any,
		}) 
		,
		ReturnType< $bog_smalljs_top_item['arg'] >
	>
	type $bog_smalljs_top_item__event_click_bog_smalljs_top_84 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $bog_smalljs_top_item['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_85 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_86 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_87 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_88 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_89 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_90 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $bog_smalljs_top_item__title_bog_smalljs_top_91 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_top_item['title'] >
	>
	type $bog_smalljs_top_item__arg_bog_smalljs_top_92 = $mol_type_enforce<
		({ 
			'section': string,
			'page': any,
		}) 
		,
		ReturnType< $bog_smalljs_top_item['arg'] >
	>
	type $bog_smalljs_top_item__event_click_bog_smalljs_top_93 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $bog_smalljs_top_item['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_94 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_95 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_96 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_97 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_98 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_99 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_expander__title_bog_smalljs_top_100 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_smalljs_top_101 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_link__title_bog_smalljs_top_102 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_103 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_104 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_view__sub_bog_smalljs_top_105 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__title_bog_smalljs_top_106 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_107 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_108 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_109 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_110 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_111 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_112 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_113 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_114 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_115 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_116 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_117 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_118 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_119 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_120 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_121 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_122 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_123 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_expander__title_bog_smalljs_top_124 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_smalljs_top_125 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_link__title_bog_smalljs_top_126 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_127 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_128 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_129 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_130 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_131 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_132 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_bog_smalljs_top_133 = $mol_type_enforce<
		({ 
			'section': string,
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_top_134 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__title_bog_smalljs_top_135 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_smalljs_top_136 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__event_click_bog_smalljs_top_137 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['nav_pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_expander__title_bog_smalljs_top_138 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_smalljs_top_139 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_view__sub_bog_smalljs_top_140 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__hint_bog_smalljs_top_141 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__align_bog_smalljs_top_142 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__trigger_content_bog_smalljs_top_143 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_bog_smalljs_top_144 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__sub_bog_smalljs_top_145 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['lang_options'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__hint_bog_smalljs_top_146 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__align_bog_smalljs_top_147 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__trigger_content_bog_smalljs_top_148 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_bog_smalljs_top_149 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $bog_theme_switch__theme_auto_bog_smalljs_top_150 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['Theme'] >
		,
		ReturnType< $bog_theme_switch['theme_auto'] >
	>
	type $mol_link_source__uri_bog_smalljs_top_151 = $mol_type_enforce<
		ReturnType< $bog_smalljs_top['github_uri'] >
		,
		ReturnType< $mol_link_source['uri'] >
	>
	type $mol_button_minor__sub_bog_smalljs_top_152 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_smalljs_top extends $mol_view {
		Logo_image( ): $mol_image
		Logo_text( ): string
		Logo_text_box( ): $mol_view
		Logo( ): $mol_link
		Search_icon( ): $mol_icon_magnify
		Search_label_text( ): string
		Search_label( ): $mol_view
		Search_hint_text( ): string
		Search_hint( ): $mol_view
		Search( ): $mol_button_minor
		Docs_label( ): string
		Docs_chevron( ): $mol_icon_chevron_down
		Docs_quickstart( ): $mol_link
		Docs_guide( ): $mol_link
		Docs_tutorial( ): $bog_smalljs_top_item
		Docs_examples( ): $mol_link
		Docs_api( ): $mol_link
		Docs_menu( ): $mol_view
		Docs_pick( ): $mol_pick
		Nav_playground( ): $bog_smalljs_top_item
		Nav_versus( ): $bog_smalljs_top_item
		Ecosystem_label( ): string
		Ecosystem_chevron( ): $mol_icon_chevron_down
		Eco_components( ): $mol_link
		Eco_libs_title_text( ): string
		Eco_libs_title( ): $mol_view
		Eco_wire( ): $mol_link
		Eco_fetch( ): $mol_link
		Eco_compare( ): $mol_link
		Eco_router( ): $mol_link
		Eco_crowd( ): $mol_link
		Eco_baza( ): $mol_link
		Ecosystem_menu( ): $mol_view
		Ecosystem_pick( ): $mol_pick
		About_label( ): string
		About_chevron( ): $mol_icon_chevron_down
		About_faq( ): $mol_link
		About_team( ): $mol_link
		About_releases( ): $mol_link
		About_telegram( ): $mol_link
		About_menu( ): $mol_view
		About_pick( ): $mol_pick
		Nav( ): $mol_view
		Burger_icon( ): $mol_icon_hamburger
		Mobile_playground( ): $bog_smalljs_top_item
		Mobile_versus( ): $bog_smalljs_top_item
		M_docs_quickstart( ): $mol_link
		M_docs_guide( ): $mol_link
		M_docs_tutorial( ): $bog_smalljs_top_item
		M_docs_examples( ): $mol_link
		M_docs_api( ): $mol_link
		Docs_group( ): $mol_expander
		M_eco_components( ): $mol_link
		M_eco_libs_title_text( ): string
		M_eco_libs_title( ): $mol_view
		M_eco_wire( ): $mol_link
		M_eco_fetch( ): $mol_link
		M_eco_compare( ): $mol_link
		M_eco_router( ): $mol_link
		M_eco_crowd( ): $mol_link
		M_eco_baza( ): $mol_link
		Ecosystem_group( ): $mol_expander
		M_about_faq( ): $mol_link
		M_about_team( ): $mol_link
		M_about_releases( ): $mol_link
		M_about_telegram( ): $mol_link
		About_group( ): $mol_expander
		Mobile_menu( ): $mol_view
		Burger( ): $mol_pick
		Lang_icon( ): $mol_icon_translate
		lang_label( ): string
		Lang_chevron( ): $mol_icon_chevron_down
		lang_options( ): readonly(any)[]
		Lang_menu( ): $mol_view
		Lang_pick( ): $mol_pick
		Theme_toggle( ): $bog_theme_switch
		Github( ): $mol_link_source
		lang_option_label( id: any): string
		Lang_option_check( id: any): $mol_icon_check
		Theme( ): any
		github_uri( ): string
		logo_uri( ): string
		search_click( next?: any ): any
		nav_pick( next?: any ): any
		sub( ): readonly(any)[]
		Lang_option( id: any): $mol_button_minor
	}
	
	export class $bog_smalljs_top_item extends $mol_link {
		uri_off( ): ReturnType< $bog_smalljs_top_item['uri'] >
	}
	
}

//# sourceMappingURL=top.view.tree.d.ts.map